export default {
  methods: {
    getProbabilityClass (probability) {
      if (probability === 100 || probability === 99 || probability === 98 || probability === 90) return 'probability-bg-dark-blue'
      if (probability === 80) return 'probability-bg-medium-blue'
      if (probability === 50) return 'probability-bg-light-blue'
      return ''
    }
  }
}
